export enum LocalStorageKeys {
  currentUser = "currentUser",
  viewAs = "viewAs",
  luckyOrangeIdentified = "luckyOrangeIdentified",
  mfa = "mfa",
}
